{
  "name": "@porsche-code/kado-dashboard-frontend",
  "version": "1.58.0",
  "private": true,
  "description": "KADO | Dashboard",
  "license": "UNLICENSED",
  "author": "codecentric AG",
  "repository": {
    "type": "git",
    "url": "https://github.com/porsche-code/kado-portal.git",
    "directory": "apps/dashboard/frontend"
  },
  "scripts": {
    "build": "vite build && tsc",
    "dev": "vite",
    "lint": "oxlint .",
    "serve": "vite preview",
    "test": "vitest",
    "release": "semantic-release",
    "codegen": "graphql-codegen --config codegen.ts",
    "generate-routes": "tsr generate"
  },
  "dependencies": {
    "@casl/ability": "catalog:",
    "@casl/react": "catalog:",
    "@hookform/resolvers": "catalog:",
    "@porsche-code/kado-analytics-client": "workspace:*",
    "@porsche-code/kado-auth": "workspace:*",
    "@porsche-code/kado-file-upload": "workspace:*",
    "@porsche-code/kado-filter-context": "workspace:*",
    "@porsche-code/kado-i18n": "workspace:*",
    "@porsche-code/kado-rum-client": "workspace:*",
    "@porsche-code/kado-styled-system": "workspace:*",
    "@porsche-code/kado-ui": "workspace:*",
    "@porsche-design-system/components-react": "catalog:",
    "@tanstack/react-query": "catalog:",
    "@tanstack/react-router": "catalog:",
    "@tanstack/react-router-devtools": "catalog:",
    "@tanstack/react-table": "catalog:",
    "@tanstack/router-plugin": "catalog:",
    "aws-amplify": "catalog:",
    "axios": "catalog:",
    "dayjs": "catalog:",
    "file-saver": "catalog:",
    "graphql": "catalog:",
    "graphql-request": "catalog:",
    "i18next": "catalog:",
    "i18next-browser-languagedetector": "catalog:",
    "i18next-http-backend": "catalog:",
    "react": "catalog:",
    "react-dom": "catalog:",
    "react-hook-form": "catalog:",
    "react-i18next": "catalog:",
    "recharts": "catalog:",
    "ua-parser-js": "^2.0.10",
    "xlsx": "catalog:",
    "zod": "catalog:"
  },
  "devDependencies": {
    "@graphql-codegen/add": "catalog:",
    "@graphql-codegen/cli": "catalog:",
    "@graphql-codegen/typescript": "catalog:",
    "@graphql-codegen/typescript-operations": "catalog:",
    "@graphql-codegen/typescript-react-query": "catalog:",
    "@porsche-code/kado-devtools": "workspace:*",
    "@porsche-code/kado-semantic-release-config": "workspace:*",
    "@tanstack/react-query-devtools": "catalog:",
    "@tanstack/router-cli": "catalog:",
    "@testing-library/dom": "catalog:",
    "@testing-library/jest-dom": "catalog:",
    "@testing-library/react": "catalog:",
    "@types/file-saver": "catalog:",
    "@types/lodash": "catalog:",
    "@types/node": "catalog:",
    "@types/react": "catalog:",
    "@types/react-dom": "catalog:",
    "@vitejs/plugin-react": "catalog:",
    "dotenv": "catalog:",
    "jsdom": "catalog:",
    "lightningcss": "catalog:",
    "lodash": "catalog:",
    "msw": "catalog:",
    "semantic-release": "catalog:",
    "semantic-release-monorepo": "catalog:",
    "tsx": "catalog:",
    "typescript": "catalog:",
    "vite": "catalog:",
    "vite-plugin-graphql-codegen": "catalog:",
    "vite-plugin-html": "catalog:",
    "vite-plugin-istanbul": "catalog:",
    "vite-plugin-svgr": "catalog:",
    "vitest": "catalog:"
  }
}
